import React, { useState } from "react";
import "./scaling.css"; // Import your CSS file for styling
import ProcessImage from "../../assets/images/process.gif"; // Import your image
import Radar from "../../assets/images/radar.gif"; // Import your image
import Brain from "../../assets/images/brain.gif"; // Import your image
import Laptop from "../../assets/images/laptop.gif"; // Import your image

const cards = [
  {
    title: "Automated Execution",
    image: ProcessImage,
    detail: `
      Radar+ doesn’t stop at identifying risks or opportunities — it acts on them.
      
      From generating tasks to assigning owners and triggering actions across Slack, Asana, Jira, and ERP systems, it ensures critical moves aren’t just planned — they’re already in progress.

      It’s not another dashboard. It’s a strategist that executes.`,
    stat: "Automated workflows reduced task lag by 65% (McKinsey).",
  },
  {
    title: "Live Signal Monitoring",
    image: Radar,
    detail: `
      Radar scans your entire ecosystem — internal metrics, external markets, competitor moves — and flags shifts before they hit revenue or operations.

      No refresh button. No lag. Just early warning and live visibility.

      You get insights when they matter most: before you need them.`,
    stat: "83% of leaders say they’ve been blindsided by avoidable risks (Deloitte).",
  },
  {
    title: "Adaptive Intelligence",
    image: Brain,
    detail: `
      Radar learns your definition of risk, opportunity, and impact — and refines alerts accordingly.

      As your company evolves, so does the system. It stops flagging noise and starts thinking like your team.

      Every signal gets filtered through your business DNA.`,
    stat: "Context-aware AI improves relevance by 74% (BCG).",
  },
  {
    title: "Impact Forecasting",
    image: Laptop,
    detail: `
      Every insight comes with a financial projection: potential loss from ignoring a risk, or the upside of acting on an opportunity.

      Radar translates complexity into clarity, helping you prioritize what drives real impact.

      Strategy isn’t just suggested. It’s justified.`,
    stat: "Forecast-led teams make decisions 2.5x faster (PwC).",
  },
];

export default function ScalingTeam() {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const closeCard = () => setExpandedIndex(null);

  return (
    <div className="section-container">
      <div className="integrations-header">
        <h2>Made for scaling team</h2>
        <p>
          Designed to scale seamlessly with growing teams, ensuring performance,
          collaboration, and reliability at every stage
        </p>
      </div>
      <div className="grid">
        {cards.map((card, index) => (
          <div key={index} className="card">
            <div className="card-inner" onClick={() => setExpandedIndex(index)}>
              <div
                className="card-image"
                style={{ backgroundImage: `url(${card.image})` }}
              />
              <div className="card-title">{card.title}</div>
              <div className="card-plus">+</div>
            </div>

            {expandedIndex === index && (
              <div className="card-overlay" onClick={closeCard}>
                <div className="card-expanded">
                  <div
                    className="expanded-image"
                    style={{ backgroundImage: `url(${card.image})` }}
                  />
                  <h2>{card.title}</h2>
                  {card.detail.split("\n").map((para, i) => (
                    <p key={i}>{para.trim()}</p>
                  ))}
                  <div className="card-stat">{card.stat}</div>
                  <button className="close-button" onClick={closeCard}>
                    Close
                  </button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
